export default __webpack_public_path__ + "resources/docs/8_cancellation_request_form.18167dfd.pdf";